export default __webpack_public_path__ + "static/media/padlock-icon.866004d6.svg";